import { Dialog, DialogTitle, Typography, IconButton, DialogContent, DialogActions, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function DispatchDialog({ show, close, title, isDispatching, onConfirmDispatch, isFromInvoiceTable }: any) {
    return (
        <Dialog
            open={show}
            onClose={close}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <b>{isFromInvoiceTable ? "Dispatch Invoices" : "Dispatch Invoice"}</b>
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={close}
                sx={(theme) => ({
                    position: "absolute",
                    right: 12,
                    top: 12,
                    color: "rgba(0, 0, 0, 0.54)",
                })}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent>
                <Typography sx={{ mt: -2 }}>
                    {title}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2, gap: 1 }}>
                <Button
                    variant="outlined"
                    onClick={close}
                    disabled={isDispatching}
                    sx={{
                        borderColor: "primary.main",
                        color: "primary.main",
                        textTransform: "none",
                        "&:hover": {
                            borderColor: "primary.main",
                            backgroundColor: "primary.main",
                            color: "white",
                        },
                    }}
                >
                    <b>CANCEL</b>
                </Button>
                <Button
                    onClick={onConfirmDispatch}
                    variant="contained"
                    disabled={isDispatching}
                    sx={{
                        backgroundColor: "primary.main",
                        color: "white",
                        textTransform: "none",
                        "&:hover": { backgroundColor: "primary.main" },
                    }}
                >
                    <b>{isFromInvoiceTable ? "YES, DISPATCH INVOICES" : "YES, DISPATCH INVOICE"}</b>
                </Button>
            </DialogActions>
        </Dialog>
    )
}